import { Component, Input } from '@angular/core';

@Component({
  selector: 'ss-skeleton',
  template: `
    <div class="ss-skeleton ss-skeleton--{{ variant }}" role="status" aria-busy="true">
      <span class="visually-hidden">Carregando…</span>
      <span *ngFor="let row of placeholders" class="ss-skeleton__row" aria-hidden="true"></span>
    </div>
  `,
  standalone: false
})
export class SkeletonComponent {
  @Input() rows = 5;
  @Input() variant: 'table' | 'card' | 'page' = 'table';

  get placeholders(): number[] {
    return Array.from({ length: Math.max(1, Math.min(20, this.rows)) }, (_, index) => index);
  }
}
